import { AxiosInstance } from 'axios'
import { IUserImportResponse, IUserImportStatusResponse } from '../../../types/usersImport.types'

export function userImportApiFactory(api: AxiosInstance) {
  const baseUrl = '/accounts/api/v1'
  return {
    async importUsers(file: File) {
      const formData = new FormData()
      formData.append('file', file)

      return api.post<IUserImportResponse>(`${baseUrl}/import/users`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    },
    getImportStatus() {
      return api.get<IUserImportStatusResponse>(`${baseUrl}/import/users/status`)
    }
  }
}
